export default "__VITE_ASSET__R7U8FFZ$__"